import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "password", "passwordConfirmation", "submitButton", "match", "length",
                    "uppercase", "lowercase", "number", "special" ]

  connect() {
    // console.log("Hello, Password Complexity Controller here!", this.element);
    // console.log(this.passwordTarget);
    // console.log(this.passwordConfirmationTarget);

    this.checkPasswordComplexity();

    this.passwordTarget.addEventListener('input', this.checkPasswordComplexity.bind(this));
    this.passwordConfirmationTarget.addEventListener('input', this.checkPasswordComplexity.bind(this));
  }

  checkPasswordComplexity() {
    let canSubmit = true;

    if ( (this.passwordTarget.value !== this.passwordConfirmationTarget.value) || (this.passwordTarget.value.length === 0 || this.passwordConfirmationTarget.value.length === 0) ) {
      this.matchTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.matchTarget.textContent = '✅';
    }

    if (this.passwordTarget.value.length < 8) {
      this.lengthTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.lengthTarget.textContent = '✅';
    }

    if (!this.passwordTarget.value.match(/[A-Z]/)) {
      this.uppercaseTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.uppercaseTarget.textContent = '✅';
    }

    if (!this.passwordTarget.value.match(/[a-z]/)) {
      this.lowercaseTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.lowercaseTarget.textContent = '✅';
    }

    if (!this.passwordTarget.value.match(/[0-9]/)) {
      this.numberTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.numberTarget.textContent = '✅';
    }

    if (!this.passwordTarget.value.match(/[#?!@$%^&*-]/)) {
      this.specialTarget.textContent = '❌';
      canSubmit = false;
    } else {
      this.specialTarget.textContent = '✅';
    }

    if (canSubmit) {
      this.submitButtonTarget.removeAttribute('disabled');
      this.submitButtonTarget.classList.remove('disabled');
    } else {
      this.submitButtonTarget.setAttribute('disabled', '');
      this.submitButtonTarget.classList.add('disabled');
    }
  }
}
